import {isNotNil} from 'ramda';

import {ELECTRIC_TYPES} from '../../../constants/electricTypes';
import {useCatalogue} from '../../../hooks/useCatalogue';
import {GetRequestApiResponse, RequestVehicle} from '../../../types/api/api';
import {WITH_VAT} from '../constants/withVAT';
import {VehicleFormType} from '../types/VehicleFormType';

export const useGetRequestVehicleFromFormData = () => {
  const {hasFeatureTranslation} = useCatalogue();

  return (formData: VehicleFormType, request?: GetRequestApiResponse): RequestVehicle => ({
    bodyStyle: formData.bodyStyle?.[0],
    drive: formData.drive?.[0],
    features: formData.features?.filter(hasFeatureTranslation),
    firstRegistrationOnYear: formData.firstRegistrationOnYear,
    fuelType: formData.fuelType?.[0],
    isVatDeductible: isNotNil(formData.isVatDeductible?.[0])
      ? formData.isVatDeductible?.[0] === WITH_VAT
      : undefined,
    make: formData.make,
    modelFamily: isNotNil(formData.make) ? formData.modelFamily : null,
    mileage: formData.mileage,
    power: formData.power,
    maxPower:
      isNotNil(formData.fuelType?.[0]) && ELECTRIC_TYPES.includes(formData.fuelType?.[0])
        ? formData.maxPower
        : undefined,
    transmission: formData.transmission?.[0],
    vin: formData.vin,
    exteriorColor: formData.exteriorColor?.[0],
    vehicleType: 'VEHICLETYPE_PASSENGER_CAR',
    seatCount: isNotNil(formData.seatCount?.[0]) ? parseFloat(formData.seatCount?.[0]) : undefined,
    doorCountCategory: formData.doorCount?.[0],
    interiorMaterial: formData.interiorMaterial?.[0],
    location: request?.vehicle?.location,
    trimLevel: formData.trimLevel,
  });
};
